import { useState } from 'react';
import MovieCard from '@/components/feature/MovieCard';
import type { Movie } from '@/mocks/movies';

interface RelatedMoviesProps {
  movies: Movie[];
}

export default function RelatedMovies({ movies }: RelatedMoviesProps) {
  if (movies.length === 0) return null;

  return (
    <section className="mt-12 md:mt-16">
      <div className="flex items-center gap-3 mb-6">
        <span className="w-10 h-10 rounded-md bg-accent-500 text-white flex items-center justify-center">
          <i className="ri-movie-2-line text-xl"></i>
        </span>
        <div>
          <p className="text-xs text-foreground-500 font-label uppercase tracking-widest">Related</p>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">相关影视推荐</h2>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {movies.map((m) => (
          <MovieCard key={m.id} movie={m} />
        ))}
      </div>
    </section>
  );
}